<section>
<div class="container">
    <button 
        class="actionButton" 
        *ngIf="showEdit" 
        id="editButton"  
        mat-mini-fab 
        aria-label="Edit Provider" 
        data-action="edit"
        [disabled]="isEditDisabled()">
        <mat-icon data-action="edit">edit</mat-icon>
    </button>

    <button 
        class="actionButton" 
        *ngIf="showCreate && canAddUserValue" 
        id="addButton" 
        mat-mini-fab 
        aria-label="Create User for Provider" 
        data-action="create"
        [disabled]="isCreateDisabled()">
        <mat-icon data-action="create">person_add</mat-icon>
    </button>

    <button 
        class="actionButton" 
        *ngIf="showDelete" 
        id="deleteButton"  
        mat-mini-fab 
        aria-label="Delete Provider" 
        data-action="delete"
        [disabled]="isDeleteDisabled()">
        <mat-icon data-action="delete">delete</mat-icon>
    </button>
</div>
</section>